import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';

export interface NavigationPathItem {
  name: string;
  hindiName?: string;
  type: 'subject' | 'section' | 'topic' | 'subtopic' | 'exam' | 'paper' | 'year';
}

@Injectable({
  providedIn: 'root'
})
export class NavigationPathService {
  private navigationPathSource = new BehaviorSubject<NavigationPathItem[]>([]);
  public navigationPath$ = this.navigationPathSource.asObservable();
  
  constructor() { }
  
  // Update the navigation path
  updateNavigationPath(pathItems: NavigationPathItem[]): void {
    this.navigationPathSource.next(pathItems);
  }
  
  // Clear the navigation path
  clearNavigationPath(): void {
    this.navigationPathSource.next([]);
  }
  
  // Get the current navigation path value
  getCurrentPath(): Observable<NavigationPathItem[]> {
    return of(this.navigationPathSource.getValue());
  }
} 